'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var Tooltip_web = require('../Tooltip/Tooltip.web.cjs');
var Typography_web = require('../Typography/Typography.web.cjs');
var Pill_web_styles = require('./Pill.web.styles.cjs');

/**
 * A visual indicator used to highlight an item's category for quick recognition
 *
 * {@link https://aviary.fullscript.io/latest/components/box/web-90x3wB8S | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Pill/Pill.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Pill = ({ intention = "neutral", size = "medium", icon, customSvg, children, tooltipContent, customCss, ...rest })=>{
    const theme = react.useTheme();
    const pillStyles = [
        Pill_web_styles.pill(theme, size, intention),
        customCss
    ];
    const textSize = ()=>{
        switch(size){
            case "xsmall":
                return "subcaption";
            case "small":
                return "footnote";
            case "medium":
                return "callout";
        }
    };
    const renderIcon = ()=>{
        if (size === "xsmall") return null;
        if (icon) {
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                "data-testid": "aviary-pill-icon",
                css: Pill_web_styles.iconWrapper,
                children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                    icon: icon
                })
            });
        }
        if (customSvg) {
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                "data-testid": "aviary-pill-icon",
                css: Pill_web_styles.iconWrapper,
                children: customSvg
            });
        }
    };
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: tooltipContent ? tooltipContent : "",
        isTooltipHidden: !tooltipContent,
        children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
            css: pillStyles,
            role: "note",
            "data-testid": "aviary-pill",
            "aria-label": children,
            ...rest,
            children: [
                renderIcon(),
                /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                    variant: textSize(),
                    customCss: Pill_web_styles.text(theme, size),
                    children: children
                })
            ]
        })
    });
};

exports.Pill = Pill;
//# sourceMappingURL=Pill.web.cjs.map
